<div class="dialog-header">
    <div class="dialogTitle">{{dialogMode}} Service Account</div>
    <mat-icon class="dialogCloseIcon" svgIcon="dialog.close" (click)="close(buttonsInfo[0].value)"></mat-icon>
</div>
<div class="dialog-content">
    <ins-input-box class="componentInDialog" [label]="'Service Account Name'" [placeholder]="''"  [validatorCfg]="[validators.Required]" [(value)]="name"
        (isValid)="updateDialogValidity($event)"></ins-input-box>
    <ins-input-box class="componentInDialog" [label]="'Domain Host'" [placeholder]="''"  [validatorCfg]="[validators.Required]" [(value)]="domainHost"
        (isValid)="updateDialogValidity($event)"></ins-input-box>

    <ins-input-box class="componentInDialog" [label]="'Service Account Subject Email'" [placeholder]="''" [validatorCfg]="emailValidator" [(value)]="subject"
        (isValid)="updateDialogValidity($event)"></ins-input-box>

    <ins-input-box class="componentInDialog" [label]="'Audience'" [placeholder]="''"  [validatorCfg]="[validators.Required]" [(value)]="audience"
        (isValid)="updateDialogValidity($event)"></ins-input-box>

    <ins-input-box class="componentInDialog" [label]="'Issuer'" [placeholder]="''"  [validatorCfg]="[validators.Required]" [(value)]="issuer"
        (isValid)="updateDialogValidity($event)"></ins-input-box>

    <ins-multiline-box class="componentInDialog" [label]="'Private Key'" [placeholder]="''" [numberOfLines]="3" [validatorCfg]="[validators.Required]" [(value)]="privateKey"
        (isValid)="updateDialogValidity($event)"></ins-multiline-box>

    <ins-multiline-box class="componentInDialog" [label]="'Public Key'" [placeholder]="''" [numberOfLines]="3" [validatorCfg]="[validators.Required]" [(value)]="publicKey"
        (isValid)="updateDialogValidity($event)"></ins-multiline-box>


</div>
<div class="dialog-footer">
  <div class="textButton" style="padding-right: 20px;" [class.disabled]="!isDialogValid" (click)="checkConnection()">Check Connection</div>
    <button class="actionButton white minWidth" (click)="close(buttonsInfo[0].value)">{{buttonsInfo[0].displayValue}}</button>
    <button class="actionButton minWidth blue" [disabled]="!isDialogValid" (click)="dialogActionHandler(buttonsInfo[1].value)">{{buttonsInfo[1].displayValue}}</button>
</div> 